module.exports = __webpack_public_path__ + "static/stack-09fa9bf85f597b319348a64d516491a7.svg";